import axios from 'axios'
export default {
  install(app) {
    window.axios = app.config.globalProperties.$axios = axios
  },
}
export function useAxios() {
  return axios
}
